interface Props {
	width?: string;
	height?: string;
}

const MoneyIconActive = ({ width = '27', height = '27' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M25.5791 13.699C25.5791 20.3702 20.1706 25.7768 13.5021 25.7768C6.83362 25.7768 1.42188 20.3718 1.42188 13.699C1.42188 7.02612 6.83042 1.62109 13.5021 1.62109C20.1737 1.62109 25.5791 7.02772 25.5791 13.699Z"
			fill="#FACC15"
		/>
		<path
			d="M8.28537 12.8245H8.71014L8.35244 10.8797C8.22948 10.1979 8.49775 9.71724 9.04548 9.62782C9.61555 9.5384 10.085 9.75077 10.1968 10.4326L10.5769 12.8245H11.7282L12.2871 10.4549C12.4436 9.77313 13.0248 9.60547 13.4384 9.60547C13.852 9.60547 14.4333 9.77313 14.5898 10.4549L15.1375 12.8245H16.3L16.68 10.4326C16.7918 9.75077 17.2613 9.5384 17.8314 9.62782C18.3679 9.71724 18.6362 10.1979 18.5132 10.8685L18.1444 12.8245H18.5803C19.0833 12.8245 19.2622 13.1263 19.2622 13.4616C19.2622 13.797 19.0721 14.1323 18.5803 14.1323H17.9096L17.2948 17.4855C17.1719 18.1561 16.6689 18.5585 16.1659 18.6032C15.6293 18.6479 15.0145 18.4244 14.8357 17.6867L14.0309 14.1323H12.846L12.0412 17.6867C11.8623 18.4244 11.2475 18.6479 10.711 18.6032C10.208 18.5585 9.70498 18.1561 9.58202 17.4855L8.95605 14.1323H8.28537C7.79354 14.1323 7.60352 13.797 7.60352 13.4616C7.60352 13.1263 7.78236 12.8245 8.28537 12.8245ZM11.0463 15.7865L11.4264 14.1323H10.7781L11.0463 15.7865ZM13.1366 12.8245H13.7291L13.4384 11.5056L13.1366 12.8245ZM15.8305 15.7753L16.0876 14.1323H15.4393L15.8305 15.7753Z"
			fill="white"
		/>
	</svg>
);

export default MoneyIconActive;
